<template>
    <b-container class="browse mx-auto bg-white rounded p-3 container">
        <b-breadcrumb v-if="this.listing_type !== 'company-listings'" class="bg-white"
                      :items="this.breadcrumb_items"></b-breadcrumb>
        <div v-if="this.criteria_breadcrumbs !== null && this.criteria_breadcrumbs.length > 0">
            <div v-if="this.window_width >= 1000">
                <b-row>
                    <b-col md="11" class="mr-2 ml-2">
                        <b-list-group horizontal="md">
                            <div v-for="item in this.criteria_breadcrumbs">
                                <b-list-group-item @click="removeCriteria(item)" variant="default"
                                                   class="criteria mr-2 close shadow flex-fill">
                                    <span class="badge badge-pill"><i class="fas fa-times fa-1x"></i></span>
                                    {{item.label}}
                                </b-list-group-item>
                            </div>
                        </b-list-group>
                    </b-col>
                </b-row>
            </div>
            <div v-else>
                <b-row>
                    <b-list-group horizontal="md">
                        <div v-for="item in this.criteria_breadcrumbs">
                            <b-row class="ml-1">
                                <b-list-group-item @click="removeCriteria(item)" variant="default"
                                                   class="criteria ml-2 mb-2 close shadow flex-fill">
                                    <span class="badge badge-pill"><i class="fas fa-times fa-1x"></i></span>
                                    {{item.label}}
                                </b-list-group-item>
                            </b-row>
                        </div>
                    </b-list-group>
                </b-row>
            </div>
        </div>
        <div v-if="this.window_width < 700">
            <vue-chunks id="results-min" ref="test" :items="listings" :columns="this.column_count" chunk-class="card-deck mb-2"
                        item-class="card border-0 shadow-none">
                <template slot-scope="slot">
                    <i v-if="typeof slot.item.placeholder == 'undefined' || slot.item.placeholder == null"
                       v-b-tooltip.hover
                       v-bind:title="[slot.item.isFavorite ? 'Unsave this listing' : 'Save this listing']"
                       v-bind:class="[slot.item.isFavorite ? 'fas fa-heart fa-1x upper-right' : 'far fa-heart fa-1x upper-right']"
                       @click="setAsFavorite(slot.item)"></i>
                    <div v-if="typeof slot.item.placeholder !== 'undefined' && slot.item.placeholder !== null">
                        <b-card class="hidden-card border-0 shadow-none"
                                style="max-width: 21rem">
                            <b-card-text class="hidden-card">
                            </b-card-text>
                        </b-card>
                    </div>
                    <div v-else>
                        <b-card overlay
                                @click="goToListing(slot.item.ListingKey)"
                                :img-src="typeof slot.item.images !== undefined ? slot.item.images.Uri800 :
                                    'https://forman-group-images.s3.amazonaws.com/no_image_available.jpg'"
                                :title="slot.item.UnparsedAddress"
                                text-variant="white">
                            <div class="bottom-price">
                                ${{ formatPrice(slot.item.CurrentPrice)}}
                            </div>
                        </b-card>
                        <div class="text-center mobile-listing-info">
                            Beds: {{slot.item.BedsTotal}} |
                            Baths: {{slot.item.BathsTotal}} |
                            {{slot.item.LivingArea}} sqft
                        </div>
                    </div>
                </template>
            </vue-chunks>
        </div>
        <div v-else>
            <b-row>
                <b-col class="col-md-12">
                    <b-card class="mt-3 border-0 shadow-none">
                        <vue-chunks id="results" ref="test" :items="listings" :columns="3" chunk-class="card-deck mb-2"
                                    item-class="card border-0 bg-transparent shadow-none col-4 listing-col">
                            <template slot-scope="slot">
                                <i v-if="typeof slot.item.placeholder == 'undefined' || slot.item.placeholder == null"
                                   v-b-tooltip.hover
                                   v-bind:title="[slot.item.isFavorite ? 'Unsave this listing' : 'Save this listing']"
                                   v-bind:class="[slot.item.isFavorite ? 'fas fa-heart fa-1x upper-right' : 'far fa-heart fa-1x upper-right']"
                                   @click="setAsFavorite(slot.item)"></i>
                                <div class="upper-left" v-if="slot.item.openHouse !== null">
                                    <i class="fas fa-door-open fa-lg"></i>Open House {{slot.item.openHouse}}
                                </div>
                                <div class="upper-left-mls"
                                     v-if="slot.item.MlsStatus !== 'Active' && slot.item.MlsStatus !== 'Active Under Contract'">
                                    {{slot.item.MlsStatus}}
                                </div>
                                <div v-if="typeof slot.item.placeholder !== 'undefined' && slot.item.placeholder !== null">
                                    <b-card class="hidden-card border-0 shadow-none"
                                            style="max-width: 21rem">
                                        <b-card-text class="hidden-card">
                                        </b-card-text>
                                    </b-card>
                                </div>

                                <div v-else>
                                    <b-card class="listing-card" @click="goToListing(slot.item.ListingKey)"
                                            :img-src="slot.item.images.Uri800 !== null ? slot.item.images.Uri800 :
                                'https://forman-group-images.s3.amazonaws.com/no_image_available.jpg'"
                                            :img-alt="slot.item.UnparsedAddress"
                                            img-top
                                            style="max-width: 21rem">
                                        <b-card-text class="card-title text-center">
                                            {{slot.item.addr1}}<br>
                                            {{slot.item.addr2}}<br>
                                            <hr width="75%">
                                            <h3>${{ formatPrice(slot.item.CurrentPrice)}}</h3>
                                            <div v-if="slot.item.PropertyType !== 'C'"
                                                 class="col-md-12 text-center mobile-show">
                                                <h6>Beds: {{slot.item.BedsTotal}} |
                                                    Baths: {{slot.item.BathsTotal}} |
                                                    {{slot.item.LivingArea}} sqft
                                                </h6>
                                            </div>
                                        </b-card-text>
                                    </b-card>
                                </div>
                            </template>
                        </vue-chunks>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col md="12">
                <div v-if="this.listing_type == 'company-listings' && this.listings.length > 0" class="text-right mb-2">
                    <b-button href="/browse" variant="default">See More Listings <i
                        class="fas fa-arrow-circle-right"></i></b-button>
                </div>
                <div v-else>
                    <b-pagination
                        v-model="pagination.current_page"
                        :total-rows="total"
                        align="center"
                        :per-page="per_page"
                        aria-controls="results"
                    ></b-pagination>
                </div>
            </b-col>
        </b-row>
        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i style="color: gray" class="fas fa-circle-notch fa-spin fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </b-container>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel';

export default {
    name: 'browse',
    components: {
        // Login_register,
        // ContactUs,
        Carousel,
        Slide
    },
    props: {
        listing_type: {
            type: String,
            default: "listings"
        },
        listing_type_id: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            window: {
                width: 0,
                height: 0
            },
            column_count: 3,
            breadcrumb_items: [],
            user_id: this.$userId,
            criteria_breadcrumbs: [],
            isLoading: false,
            neighborhoods: [],
            styles: [],
            resultSet: [],
            listings: [],
            is_search_results: false,
            show_closed_listings: false,
            pagination: {
                current_page: 1,
                total: null,
                per_page: 24
            },
            listing: {
                isFavorite: null
            },
        }
    },
    created() {
        this.isLoading = true;

        if (this.$route.query.search !== null) {
            this.getSearchObject(this.$route.query.search);
        }
        this.getListings();
        this.isLoading = false;
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        getSearchObject(searchString) {
            this.criteria_breadcrumbs = [];
            if (typeof searchString !== 'undefined') {
                this.criteria_breadcrumbs.push(
                    {
                        'text': 'searchString',
                        'value': searchString,
                        'label': '"' + searchString + '"'
                    });
            }
        },
        clear() {
            this.criteria_breadcrumbs = [];
            let query = Object.assign({}, this.$route.query);
            delete query.search;
            this.$router.replace({query});
            this.getListings();
        },
        formatPrice(val) {
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        goToListing(id) {
            window.open('../../listing/' + id, '_blank');
        },
        setAsFavorite(listing) {
            let _self = this;

            if (_self.user_id === '0') {
                window.location.href = '/login';
            } else {

                _self.listing = listing;

                let data = {
                    user_id: _self.user_id,
                    listing_id: listing.ListingKey,
                    listing_address: listing.UnparsedAddress
                };

                let route = listing.isFavorite ? '/api/favorites/delete' : '/api/favorites/add';
                listing.isFavorite = !listing.isFavorite;

                axios.post(route, data)
                    .then(function (response) {
                        if (response.data.status === false) {
                            _self.toast("We're very sorry but there has been an error. Please try again later.", "error", 'danger');
                        } else {
                            _self.toast('Listing status saved!', 'success');
                        }
                    });
            }
        },
        loginModalShow() {
            this.$refs['loginRegisterModal'].show();
        },
        addCriteria(criterion) {
            let _self = this;

            this.addToCriteriaObject(criterion);

            _self.isLoading = true;
            _self.getListings();
        },
        removeCriteria(criterion) {
            let _self = this;
            for (var i = 0; i < _self.criteria_breadcrumbs.length; i++) {
                if (_self.criteria_breadcrumbs[i].value === criterion.value) {
                    _self.criteria_breadcrumbs.splice(i, 1);
                    break;
                }
            }
            _self.getListings();
        },
        addToCriteriaObject(criterion) {
            let found = false;
            let _self = this;

            for (var i = 0; i < _self.criteria_breadcrumbs.length; i++) {
                if (_self.criteria_breadcrumbs[i].value === criterion.value) {
                    found = true;
                    break;
                }
            }
            if (found === false) {
                _self.criteria_breadcrumbs.push(criterion);
            }
        },
        getListings() {
            let _self = this;
            _self.isLoading = true;

            let query = Object.assign({}, _self.$route.query);

            let data = {};
            let route = '/api/' + this.listing_type;

            if (typeof this.listing_type !== "undefined" && this.listing_type !== null && this.listing_type.includes("agent")) {
                data = {
                    sort: 'ModificationTimestamp',
                    order: 'DESC',
                    page: _self.current_page,
                    size: 6,
                    listing_type_id: _self.listing_type_id,
                };
            } else {
                data = {
                    user_id: this.$userId,
                    criteria: _self.criteria_breadcrumbs,
                    page: _self.current_page,
                    show_closed_listings: _self.show_closed_listings,
                    query
                };
            }

            let promise = axios.post(route, data);

            return promise.then((response) => {
                _self.isLoading = false;

                if (typeof response.data.listings !== 'undefined') {
                    _self.listings = $.map(response.data.listings, function (dataItem) {
                        return dataItem;
                    });
                    _self.pagination = response.data.pagination;
                    _self.breadcrumb_items = response.data.breadcrumbs;
                    _self.criteria = response.data.criteria;
                    //bool value
                    _self.is_search_results = response.data.is_search_results;

                    if (_self.criteria_breadcrumbs == null) {
                        _self.criteria_breadcrumbs = [];
                    }

                    if (typeof response.data.criteria !== 'undefined' && response.data.criteria.length > 0) {
                        this.addToCriteriaObject(response.data.criteria.searchString);
                    }
                }
            });
        },
        includeClosedListings() {
            this.show_closed_listings = !this.show_closed_listings;
        },
        toast(message, variant) {
            this.$bvToast.toast(message, {
                title: variant,
                variant: variant,
                solid: true
            })
        },
        logged_in(response) {
            this.user_id = response;
            this.$refs['loginRegisterModal'].hide();
        },
        submitCriteria(data) {
            let _self = this;
         //   _self.criteria_breadcrumbs = [];

            _self.$eventHub.$emit('exit', true);
            data.forEach(element => this.addCriteria(element));

            _self.getListings();
        }
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.listings.length;
        this.$eventHub.$on('criteria::submit', this.submitCriteria);
        this.$eventHub.$on('login::success', this.logged_in);
        this.$eventHub.$on('criteria::added', this.addCriteria);
        this.$eventHub.$on('criteria::removed', this.removeCriteria);
        this.$eventHub.$on('criteria::cleared', this.clear);
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return {text: f.label, value: f.key}
                })
        },
        total() {
            return this.pagination.total
        },
        current_page() {
            return this.pagination.current_page
        },
        per_page() {
            return this.pagination.per_page
        },
        has_criteria() {
            if (this.criteria_breadcrumbs !== null) {
                return this.criteria_breadcrumbs.length > 0;
            }
        },
        loggedInUser() {
            // return this.$userId !== "" && typeof this.$userId !== 'undefined';
        },
        window_width() {
            return this.window.width;
        },
        page_title() {
            switch (this.listing_type) {
                case 'favorites':
                    return "My Favorites";
                case 'openHouses':
                    return "Open Houses";
                case 'company-listings':
                    return "Current Listings";
                default:
                    return null;
            }
        },
        chunkedItems () {
            return _.chunk(_.toArray(this.listings), 3);
        }
    },
    watch: {
        listing_type_id: function () {
            this.getListings();
        },
        current_page: function () {
            this.getListings();
        },
        per_page: function (val) {
            this.getListings();
        },
        window_width() {
            if (this.window_width < 767) {
                this.column_count = 2;
            } else {
                this.column_count = 3;
            }
        }
    }
}

</script>

<style lang="scss" scoped>
.clear {
    color: gray;
}

i:hover:before {
    height: 42px;
    color: deeppink;
}

.criteria {
    font-size: small;

    .button {
        color: gray;
    }
}

#loading {
    background: rgba(255, 255, 255, 0.6);
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 10010;
    top: 0;
    left: 0;
    text-align: center;
}

#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
}

.wrapper {
    position: relative;
}

.wrapper span.fas {
    position: absolute;
    top: 20px;
    left: 20px;
    color: white;
    box-shadow: 0 0 5px 5px #000;
}

.card {
    height: 100%;
    width: 100%;
}

.upper-right {
    position: absolute;
    top: 5px;
    right: 10px;
    z-index: 2;
    color: red;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    padding: 5px;

    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 667px)
    {
        right: 5px;
    }
}

.upper-left {
    position: absolute;
    top: 5px;
    left: 35px;
    z-index: 2;
    color: black;
    background: rgba(255, 255, 255, 0.7);
    padding: 5px;
}

.upper-left-mls {
    position: absolute;
    top: 5px;
    left: 35px;
    z-index: 2;
    color: red;
    background: rgba(255, 255, 255, 0.7);
    padding: 5px;
}

.bottom-price {
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 2;
    border-radius: 10%;
    padding: 5px;
    color: white;
    background: rgba(0,0,0,0.3);
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
}

.neighborhood ul {
    max-height: 200px;
    overflow-y: scroll;
}

.listing-col {
    padding: 0;
}

.hidden-card {
    display: none;
}

@media only screen
and (min-device-width: 300px)
and (max-device-width: 370px)
and (-webkit-min-device-pixel-ratio: 2) {
    .card-title {
        text-shadow: 0 0 5px rgba(0,0,0,1);
        font-size: medium;
    }
}

@media only screen
and (min-device-width: 375px)
and (max-device-width: 667px)
and (-webkit-min-device-pixel-ratio: 2) {
    .card .card-img {
        min-height: 100px;
        max-height: 200px;
    }
    .card-title {
        text-shadow: 0 0 5px rgba(0,0,0,1);
        font-size: medium;
    }
}

@media only screen
and (min-device-width: 668px)
and (max-device-width: 767px)
and (-webkit-min-device-pixel-ratio: 2) {
    .card .card-img {
        min-height: 100px;
        max-height: 200px;
    }
    .card-title {
        text-shadow: 0 0 5px rgba(0,0,0,1);
        font-size: medium;
    }
}

@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
{
    .card .card-img {
        min-height: 150px;
        max-height: 150px;
    }
}

@media screen
and (min-device-width: 1200px)
and (max-device-width: 1600px)
{
    .card {
        min-height: 295px
    }
}

.mobile-listing-info {
    margin-top: -15px;
}

</style>
